export default __webpack_public_path__ + "static/media/element_11.b47d965f.webp";